import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import * as node from '../../node'
import type { Key } from '../key'

/**
 * Represents a function to be evaluated
 */
export abstract class Node<
  T = unknown,
  TKey extends Key = Key,
  TArg = unknown,
> extends node.Node<T> {
  constructor(
    public readonly key: TKey,
    public readonly arg: TArg,
  ) {
    super()
  }
}
export namespace Node {
  export const isNode: TypeChecker<Node> = TypeChecker.Factory.lazy(() =>
    TypeChecker.Factory.instance(Node),
  ).usingAlias('dms.data.expression.fn.node.Node')
  export const assertIsNode: TypeAsserter<Node> =
    TypeAsserter.Factory.from(isNode)
}
